import { Link, NavLink, Routes, Route } from "react-router-dom";
import "./styles.css";

export default function App() {
    return (
        <div className="App">
            <div className="Header">
                <ul>
                    <li>
                        <NavLink
                            to="/"
                            style={({ isActive }) => ({
                                textDecoration: isActive ? "underline" : "none"
                            })}
                        >
                            Home
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/router"
                            style={({ isActive }) => ({
                                textDecoration: isActive ? "underline" : "none"
                            })}
                        >
                            React Router
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/animate"
                            style={({ isActive }) => ({
                                textDecoration: isActive ? "underline" : "none"
                            })}
                        >
                            Animate Presence
                        </NavLink>
                    </li>
                </ul>
            </div>

            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/router" element={<ReactRouter />} />
                <Route path="/animate" element={<AniPresence />} />
            </Routes>
        </div>
    );
}

function Home() {
    return (
        <div className="Home">
            <div className="content">
                <h2>Home</h2>
                <p>
                    By using <Link to="/router">React Router</Link> in
                    combination with Framer Motion’s{" "}
                    <Link to="/animate">Animate Presence</Link> we can animate
                    between separate webpages.
                </p>
            </div>
        </div>
    );
}

function ReactRouter() {
    return (
        <div className="Router">
            <div className="content">
                <h2>React Router</h2>
                <p>
                    React Router is a collection of{" "}
                    <b>navigational components</b> that compose declaratively
                    with your application.
                </p>
                <p>
                    Whether you want to have <b>bookmarkable URLs</b> for your
                    web app or a composable way to navigate in{" "}
                    <b>React Native</b>, React Router works wherever React is
                    rendering.
                </p>
            </div>
        </div>
    );
}

function AniPresence() {
    return (
        <div className="Animate">
            <div className="content">
                <h2>Animate Presence</h2>
                <p>
                    <b>AnimatePresence</b> allows components to animate out when
                    they’re removed from the React tree.
                </p>
                <p>
                    It’s required to enable exit animations because React lacks
                    a lifecycle method that:
                </p>
                <ul>
                    <li>
                        Notifies components when they’re going to be unmounted
                        and
                    </li>
                    <li>
                        Allows them to defer that unmounting until after an
                        operation is complete (for instance an animation).
                    </li>
                </ul>
            </div>
        </div>
    );
}
